import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import {geoUtils} from '../utils/geo-utils';

class HeatMapShapes extends Component {

  shouldComponentUpdate(nextProps){
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const dataDictDifferent = nextProps.dict !== this.props.dict;
    const dataPropDifferent = nextProps.dimX !== this.props.dimX;

    return widthDifferent || heightDifferent || dataPropDifferent || dataDictDifferent;
  }

  render() {
    const onClick = this.props.onClick;
    const onHover = this.props.onHover;
    const dataProp = this.props.dimX;
    const dataDict = this.props.dict;

    const paths = geoUtils.getAlbersUsaCountyPaths(this.props.width, this.props.height);

    const heatScale = d3.scaleLinear()
      .domain([2, 7, 14, 21, 28])
      .range(['#e8e8e8', '#e4acac', '#c85a5a', '#985356', '#5d434c', '#31282b']);

    const heatValue = d => _.get(dataDict, [d.id, dataProp], 2);

    return (
      <g className="HeatMapShapes">
        {paths.map(d => {
          const value = heatValue(d);

          return (<path
            key={d.id}
            className={'land HEAT_' + value}
            d={d.path}
            id={'HEAT_' + value}
            fill={heatScale(value)}
            onMouseEnter={() => {
              const coords = d.cent;
              const data = _.get(dataDict, [d.id], null);

              if (onHover) {
                onHover({coords, data})
              }

              d3.select('.HeatBarChart').attr("class", "HeatBarChart highlight-" + heatValue(d));
            }}
            onMouseOut={() => {
              if (onHover) {
                onHover(null)
              }
              d3.select('.HeatBarChart').attr("class", "HeatBarChart");
            }}
            onClick={() => {
              if (onClick) {
                onClick(d.stateFips, d.countyFips)
              }
            }}
          ></path>);
        })}
      </g>
    )
  }
}

HeatMapShapes.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  dict: PropTypes.object,
  dimX: PropTypes.string,
};

export default HeatMapShapes


// WEBPACK FOOTER //
// ./src/charts/HeatMap/HeatMapShapes.js